<div class="page-section">

    <p class="page-heading">Privacy Policy</p>

    <p class="page-description">
    WealthGrowth.AI is committed to protecting the privacy of its users. This Privacy Policy outlines the types of data we collect, how we use and protect that data, and the rights users have regarding their personal information.</p>

    <p class="page-description-heading">Information We Collect</p>
    <p class="page-description-sub-heading">Personal Information</p>
    <p class="page-description">
      When users create an account on WealthGrowth.AI, we collect personal information such as name, email address, phone number, company name, and job title.</p>
      <p class="page-description-sub-heading">Usage Data</p>
    <p class="page-description">
      We collect information on how users interact with our app, including logins and session times, features accessed, actions taken within the app, and meeting schedules and histories.</p>

    <p class="page-description-heading">How We Use Collected Information</p>
    <p class="page-description-sub-heading">To Provide and Improve Our Services</p>
    <p class="page-description">
      We use the collected information to authenticate users and maintain their accounts, facilitate meeting scheduling and management, personalize user experience, and improve the functionality and performance of our app.</p>
      <p class="page-description-sub-heading">Communication</p>
    <p class="page-description">
      We may use the information to communicate with users about account updates and scheduling meetings.</p>
      <p class="page-description-sub-heading">Analytics</p>
    <p class="page-description">
      We use usage data and device information for analytical purposes to understand how users interact with our app and to make improvements.</p>

    <p class="page-description-heading">Data Collection Methods</p>
    <p class="page-description-sub-heading">Direct Collection</p>
    <p class="page-description">
      We collect personal information directly from users when they create an account, schedule meetings, or interact with customer support.</p>

    <p class="page-description-heading">Data Protection</p>
    <p class="page-description-sub-heading">Security Measures</p>
    <p class="page-description">
      We implement various security measures to protect user data, including encryption, access controls, and secure servers.</p>
      <p class="page-description-sub-heading">Data Retention</p>
    <p class="page-description">
      We retain personal information as long as necessary to provide our services and for legitimate business purposes. Users can request deletion of their data by contacting support.</p>

    <p class="page-description-heading">User Rights</p>
    <p class="page-description-sub-heading">Access and Correction</p>
    <p class="page-description">
      Users can access and update their personal information through their account settings.</p>
      <p class="page-description-sub-heading">Consent Withdrawal</p>
    <p class="page-description">
      Users can withdraw consent for data processing by changing their account settings or contacting support.</p>

    <p class="page-description-heading">Changes to Privacy Policy</p>
    <p class="page-description">
      We may update this Privacy Policy from time to time. Users will be notified of any significant changes through the app or email.</p>

  <p class="page-description page-content-bold">
    For questions or concerns about this Privacy Policy, please contact us at: <a href="mailto:contact@cognerium.com" target="_blank" class="page-link-text">contact@cognerium.com</a>
  </p>

</div>
